import React, { FC } from 'react'
import { Field } from 'redux-form'
import { Input } from 'semantic-ui-react'
//@ts-ignore
import { ComponentContainer } from 'shared/StyledComponents'
import { AccSearchPersonalNoComponentProps } from '../components.type'

const component: FC<AccSearchPersonalNoComponentProps> = ({ input, meta: { submitting }, type }) => (
  <ComponentContainer input>
    <Input
      fluid
      {...input}
      onChange={(_, { value }) => input.onChange(value)}
      onFocus={(e: React.FocusEvent<HTMLInputElement>) => e.target.select()}
      type={type}
      loading={submitting}
      maxLength={20}
    />
  </ComponentContainer>
)

const textNormalizer = () => (value: string, prevValue: string) => {
  if (value) {
    if (!/^[0-9a-zA-Z\-_]+$/.test(value)) return prevValue
    return value
  }
  return ''
}

const AccSearchPersonalNo = () => (
  <Field name="personalNo" component={component} type="text" normalize={textNormalizer()} />
)

export default AccSearchPersonalNo
